module.exports = __webpack_public_path__ + "static/media/21ECLAC33.fd4127bf.jpg";